import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationGroups.ts
var testData = {
	locationGroups: [
		{
			color: "rgb(125,156,187)",
			description: "Locations in the West side of Town",
			id: "ID_01",
			organizationId: "AB1",
			regionIds: ["rgn-"],
			title: "West Locations"
		},
		{
			color: "#d66b1f",
			description: "Locations in the East side of Town",
			id: "ID_02",
			organizationId: "AB1",
			regionIds: ["rgn-"],
			title: "East Locations"
		},
		{
			color: "#8bdc4a",
			description: "Locations in the South side of Town",
			id: "ID_03",
			organizationId: "AB1",
			regionIds: ["rgn-"],
			title: "South Locations"
		}
	],
	total: 3
};
function useLocationGroups(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationGroupsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationGroups };

//# sourceMappingURL=useLocationGroups.js.map